import { APIClient } from "./axiosClient";

const api = new APIClient();
const path = "/sections";

const sectionApi = {
  getSections(params?: any): Promise<any> {
    const url = `${path}`;
    return api.get(url, params);
  },

  getSectionItems(id: any, params?: any): Promise<any> {
    const url = `${path}/${id}/items`;
    return api.get(url, params);
  },

  removeItemSection(id: any): Promise<any> {
    const url = `${path}/${id}/remove-item`;
    return api.delete(url);
  },

  getSectionDetail(id: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.get(url);
  },

  postSection(dataForm: any): Promise<any> {
    const url = `${path}`;
    return api.post(url, dataForm);
  },

  putSection(id: any, dataForm: any): Promise<any> {
    const url = `${path}/${id}`;
    return api.put(url, dataForm);
  },

  putItemSection(dataForm: any): Promise<any> {
    const url = `${path}/batch-update-items`;
    return api.put(url, dataForm);
  },

  deleteSection(id: any) {
    return api.delete(`${path}/${id}`);
  },
};

export default sectionApi;
